import React from "react";
import "./style.css";

const VaporOverlay = props => {
  const { children, visible } = props;
  if (!visible) {
    return null;
  }
  return (
    <div className="ts-vapor-overlay">
      <div className="ts-vapor-overlay-children-container">{children}</div>
    </div>
  );
};

export default VaporOverlay;
